import React, { useState, useEffect } from "react";
import ContinueReadingWidget from "../components/portal/ContinueReadingWidget";
import BackedCampaignsWidget from "../components/portal/BackedCampaignsWidget";
import BrowseReaderWidget from "../components/BrowseReaderWidget";
import BrowseCrowdfundWidget from "../components/BrowseCrowdfundWidget";
import FeaturedCampaignWidget from "../components/FeaturedCampaignWidget";
import { PortalButton } from "../components/portal/PortalButton";
import ThreeAppLinks from "../components/portal/ThreeAppLinks";
import PortalLoginCTA from "../components/portal/PortalLoginCTA";
import HeroCarousel from "../components/portal/HeroCarousel";
import BrandValuesSection from "../components/portal/BrandValuesSection";
import ParallaxBackground from "../components/portal/ParallaxBackground";
import Footer from "../shared/Footer";
import "../styles/portal.css";

import { useAuth } from "../contexts/AuthContext";

export default function PortalHome() {
  const { user } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const heroOverlayStyle = {
    position: "absolute",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.45)",
    zIndex: 1,
  };

  const heroContentStyle = {
    position: "relative",
    zIndex: 2,
    maxWidth: "960px",
    margin: "0 auto",
    padding: "16px 16px 0",
  };

  return (
    <div style={{ width: "100%", margin: 0, padding: 0, overflowX: "hidden" }}>
      <div style={{ position: "relative", width: "100%", margin: 0, padding: 0 }}>
        <ParallaxBackground isMobile={isMobile} />
        <div style={heroOverlayStyle} />
        <div style={heroContentStyle}>
          <HeroCarousel />
          <ThreeAppLinks />
          {!user && <PortalLoginCTA />}
          {user &&
            <PortalSection title="For You">
              <div className="portal-grid portal-grid--personal">
                <ContinueReadingWidget />
                <BackedCampaignsWidget />
              </div>
            </PortalSection>
          }
          <BrandValuesSection />
        </div>
      </div>
      <Footer style={{ marginTop: 0 }} />
    </div>

  );
}



function PortalSection({ title, children }) {
  return (
    <section className="portal-section">
      <div className="portal-section__header">
        <h2 className="portal-section__title">{title}</h2>
      </div>
      {children}
    </section>
  );
}
